export const captureFrameRateOptions = [0, 1, 2, 4, 8, 10] as const
export const processingFrameRateOptions = [0, 1, 2, 4, 8] as const

export interface PerformanceSettings {
  /** Zero preserves the existing browser request (ideal 10 FPS, no maximum). */
  captureFpsLimit: number
  /** Zero preserves the existing metric-driven scheduler. */
  processingFpsLimit: number
}

export function normalizePerformanceSettings(value: unknown): PerformanceSettings {
  const input = value && typeof value === 'object' ? value as Partial<PerformanceSettings> : {}
  return {
    captureFpsLimit: captureFrameRateOptions.some(option => option === input.captureFpsLimit) ? input.captureFpsLimit! : 0,
    processingFpsLimit: processingFrameRateOptions.some(option => option === input.processingFpsLimit) ? input.processingFpsLimit! : 0,
  }
}

export function captureFrameRateConstraint(limit: number): ConstrainDouble {
  const { captureFpsLimit } = normalizePerformanceSettings({ captureFpsLimit: limit })
  return captureFpsLimit ? { ideal: captureFpsLimit, max: captureFpsLimit } : { ideal: 10 }
}

export function limitedProcessingInterval(intervalMs: number, limit: number): number {
  const { processingFpsLimit } = normalizePerformanceSettings({ processingFpsLimit: limit })
  return processingFpsLimit ? Math.max(intervalMs, 1_000 / processingFpsLimit) : intervalMs
}
